import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { LogIn, LogOut, MapPin } from "lucide-react";

export default function Home() {
  const navigate = useNavigate();

  useEffect(() => {
    const handleKeyDown = (event) => {
      // Check for Alt + A
      if (event.altKey && (event.key === "a" || event.key === "A")) {
        event.preventDefault();
        navigate("/admin");
      }
    };

    window.addEventListener("keydown", handleKeyDown);
    return () => window.removeEventListener("keydown", handleKeyDown);
  }, [navigate]);

  return (
    <div className="min-h-screen flex flex-col relative overflow-hidden">
      {/* Background texture */}
      <div
        className="absolute inset-0 bg-cover bg-center"
        style={{
          backgroundImage: `url('https://images.pexels.com/photos/1597623/pexels-photo-1597623.jpeg')`,
        }}
      />
      <div className="absolute inset-0 bg-white/85" />

      {/* Content */}
      <div className="relative z-10 flex-1 flex flex-col justify-center px-6 py-12 max-w-lg mx-auto w-full">
        {/* Brand */}
        <div className="animate-fade-in">
          <p className="overline text-[#002FA7] mb-3" data-testid="event-overline">
            Event Attendance
          </p>
          <div className="mb-6">
            <img 
              src="/EO Odisha Logo.png" 
              alt="EO Odisha Logo" 
              className="h-24 sm:h-32 w-auto object-contain"
            />
          </div>
          <p className="text-base text-[#525252] leading-relaxed max-w-sm" data-testid="event-subtitle">
            Member Integration Event
          </p>
          <div className="flex items-center gap-2 mt-2 mb-10 group" data-testid="event-location">
            <MapPin className="w-4 h-4 text-[#002FA7]" />
            <a 
              href="https://maps.app.goo.gl/PBqRJTbZvHUUyLWQ9" 
              target="_blank" 
              rel="noopener noreferrer"
              className="text-sm font-semibold text-[#525252] hover:text-[#002FA7] transition-colors decoration-[#002FA7]/30 underline underline-offset-4"
            >
              Lord Of The Drinks
            </a>
          </div>
        </div>

        {/* Action cards */}
        <div className="space-y-4">
          <button
            onClick={() => navigate("/in")}
            className="swiss-card w-full p-6 text-left animate-fade-in animate-delay-2 group cursor-pointer"
            data-testid="navigate-checkin"
          >
            <div className="flex items-center justify-between">
              <div>
                <p className="overline text-[#525252] mb-2">Step 1</p>
                <p className="text-xl font-bold text-[#0A0A0A]">Check In</p>
                <p className="text-sm text-[#525252] mt-1">Register your entry at the event</p>
              </div>
              <LogIn className="w-6 h-6 text-[#002FA7] group-hover:translate-x-1 transition-transform" />
            </div>
          </button>

          <button
            onClick={() => navigate("/out")}
            className="swiss-card w-full p-6 text-left animate-fade-in animate-delay-3 group cursor-pointer"
            data-testid="navigate-checkout"
          >
            <div className="flex items-center justify-between">
              <div>
                <p className="overline text-[#525252] mb-2">Step 2</p>
                <p className="text-xl font-bold text-[#0A0A0A]">Check Out</p>
                <p className="text-sm text-[#525252] mt-1">Log your exit and share feedback</p>
              </div>
              <LogOut className="w-6 h-6 text-[#002FA7] group-hover:translate-x-1 transition-transform" />
            </div>
          </button>
        </div>
      </div>

      {/* Footer */}
      <div className="relative z-10 pb-6 text-center">
        <p className="text-xs text-[#525252]/60">EO Odisha Event System</p>
      </div>
    </div>
  );
}
